import type { CustomerPrivacyApi } from "src/WishlistApp";

export interface VisitorConsent {
  marketingAllowed: boolean;
  saleOfDataAllowed: boolean;
  analyticsAllowed: boolean;
  preferencesAllowed: boolean;
}

const consentTrackingApiPromise = new Promise<CustomerPrivacyApi>(
  (resolve, reject) => {
    window.Shopify.loadFeatures(
      [
        {
          name: "consent-tracking-api",
          version: "0.1",
        },
      ],
      (error) => {
        if (error || !window.Shopify.customerPrivacy) {
          reject(
            error ? error : new Error("Shopify.customerPrivacy not available"),
          );
        } else {
          resolve(window.Shopify.customerPrivacy);
        }
      },
    );
  },
);

export const onVisitorConsent = (
  callback: (visitorConstent: VisitorConsent) => void,
) => {
  consentTrackingApiPromise
    .then((customerPrivacy) => {
      callback({
        marketingAllowed: customerPrivacy.marketingAllowed(),
        saleOfDataAllowed: customerPrivacy.saleOfDataAllowed(),
        analyticsAllowed: customerPrivacy.analyticsProcessingAllowed(),
        preferencesAllowed: customerPrivacy.preferencesProcessingAllowed(),
      });
    })
    .catch((error) => {
      console.warn("Failed to load Customer Privacy API", error);
    });

  document.addEventListener("visitorConsentCollected", (event: Event) => {
    if ("detail" in event) {
      callback((event as CustomEvent).detail as VisitorConsent);
    }
  });
};
